// extracted by mini-css-extract-plugin
module.exports = {"parentDiv":"VideoCard_parentDiv__1NIcB","iconclass":"VideoCard_iconclass__3Sg4X","iconPrimary":"VideoCard_iconPrimary__2cLAb","iconHorizontal":"VideoCard_iconHorizontal__36XMJ"};